import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Indicator} from '../indicator';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-number-scroll',
  templateUrl: './number-scroll.component.html',
  styleUrls: ['./number-scroll.component.css']
})
export class NumberScrollComponent implements OnInit {
  eventText = '';
  indicators;
   @Input() nameChamp: string;
   @Input() labelChamp: string;
   @Input() debutcount: number;
   @Input() min: number;
   @Input() max: number;
   @Input() incrementingValue?: number;
   @Output() numeroChange = new EventEmitter<number>();
   numberField = new FormControl('');
  constructor() {
    this.indicators = new Indicator();
  }
  ngOnInit(): void {
    if (!this.incrementingValue) {this.incrementingValue = 1; }
  }

  emitNumberChange(numero: number): void {this.numeroChange.emit(numero); }
  onPress(evt) {
    const gestureIndicator = this.indicators.display(
      evt.center.x,
      evt.center.y,
      50
    );
    gestureIndicator.interval = setInterval(() => {
      if (this.debutcount < this.max) {
        this.debutcount += +(this.incrementingValue);
        this.emitNumberChange(this.debutcount);
      }
    }, 200);
    this.eventText += `(${evt.center.x}, ${evt.center.y})<br/>`;

  }

  onPressDown(evt) {
    const gestureIndicator = this.indicators.display(
      evt.center.x,
      evt.center.y,
      50
    );

    gestureIndicator.interval = setInterval(() => {
      if (this.debutcount > this.min) {
        this.debutcount -= +(this.incrementingValue);
        this.emitNumberChange(this.debutcount);
      }
    }, 200);
    this.eventText += `(${evt.center.x}, ${evt.center.y})<br/>`;

  }

pressOne() {
  if (this.debutcount < this.max) {
    this.debutcount += +(this.incrementingValue);
    this.emitNumberChange(this.debutcount);
  }
}
  pressDownOne() {
    if (this.debutcount > this.min) {
      this.debutcount -= +(this.incrementingValue);
      this.emitNumberChange(this.debutcount);
    }
  }
  onPressUp(evt) {
    const indicator = this.indicators.gestureIndicators[0];
    if (indicator) {
      clearInterval(indicator.interval);
      this.indicators.hide(indicator);
    }
  }

  formTONumber() {
    this.debutcount = this.numberField.value;
    this.emitNumberChange(this.debutcount);
  }
}
